


<div class="container-fluid py-2">
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm p-4">


         <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="fw-bold">Existing Links</h5>
          <!-- Add Testimonial Button -->
          <button class="btn btn-primary btn-sm" (click)="socialModel = true">
            <i class="fas fa-plus me-1"></i> Add Social Media Link
          </button>
        </div>
    <table class="table table-bordered text-center mt-2">
  <thead class="bg-dark text-white">
    <tr>
      <th scope="col">Platform</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody class="text-center">
    <!-- Existing Links -->
    <tr *ngFor="let item of socialMediaLinks">
      <td>
        <ng-container *ngIf="item.link?.trim(); else noLink">
          <!-- Platform Icon -->
          <i 
            [ngClass]="{
              'bi bi-facebook text-primary': item.name == 'Facebook',
              'bi bi-twitter text-info': item.name === 'Twitter',
              'bi bi-instagram text-danger': item.name === 'Instagram',
              'bi bi-linkedin text-primary': item.name === 'LinkedIn',
              'bi bi-whatsapp text-success': item.name === 'WhatsApp'
            }"
            class="me-2"
          ></i>
         <a [href]="item.link" target="_blank" class="text-decoration-none">
  {{ item.name ? item.name + ' (' + item.link + ')' : '-' }}
</a>

        </ng-container>
        <ng-template #noLink>
          <span>-</span>
        </ng-template>
      </td>
      <td>
  <div class="d-flex align-items-center justify-content-center gap-2">
    <!-- Toggle Switch -->
    <label class="switch m-0" title="Click to change Status">
      <input type="checkbox" [checked]="item.status === 'Active'" (change)="toggleStatus(item.socialMediaSeq, $event)" />
      <span class="slider round"></span>
    </label>

    <!-- Edit Button -->
    <button class="btn btn-sm btn-outline-primary" (click)="editLink(item)" title="Edit">
      <i class="bi bi-pencil-fill"></i>
    </button>

    <!-- Delete Button -->
    <button class="btn btn-sm btn-outline-danger" (click)="deleteLink(item.socialMediaSeq)" title="Delete">
      <i class="bi bi-trash-fill"></i>
    </button>
  </div>
</td>

    </tr>

    <!-- No Links -->
    <tr *ngIf="!socialMediaLinks || socialMediaLinks.length === 0">
      <td colspan="2" class="text-center py-5">
        <i class="fas fa-link fa-2x d-block mb-2 text-secondary"></i>
        <span class="fw-bold text-secondary">-- No social media links found --</span>
      </td>
    </tr>
  </tbody>
</table>





        <!-- Existing Testimonials List -->
       

      </div>
    </div>
  </div>
</div>





   <div class="modal" 
     style="background-color: rgba(54,54,54,0.47)"
     tabindex="-1" role="dialog" 
     aria-hidden="true"
     [style.display]="socialModel ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-bold" id="addTestimonialLabel">
         {{ isUpdate ? 'Update Social Media Link' : 'Add New Social Media Links' }} 
        </h5>
        <button type="button" class="btn-close" (click)="closeModel()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="max-height: 80vh; overflow-y: auto;">

  <!-- Form to add/update links -->
  <form [formGroup]="socialMediaForm" (ngSubmit)="socialMediaValidation()">
    <div class="row g-3">

      <!-- Facebook -->
     <div class="col-md-6" *ngIf="!this.updateInput || updateInput == 'Facebook'">
  <label for="facebook" class="form-label">Facebook</label>
  <input type="url" id="facebook" formControlName="facebook" class="form-control"
         placeholder="https://facebook.com/yourpage"
         [ngClass]="{
           'is-invalid': socialMediaForm.get('facebook')?.touched && socialMediaFormErrors.facebook,
           'is-valid': socialMediaForm.get('facebook')?.valid && socialMediaForm.get('facebook')?.touched
         }" >
  <small class="text-danger fw-bold" *ngIf="socialMediaForm.get('facebook')?.touched && socialMediaFormErrors.facebook">
    <i class="fas fa-exclamation-circle"></i> {{ socialMediaFormErrors.facebook }}
  </small>
</div>


      <!-- Twitter -->
      <div class="col-md-6" *ngIf="!this.updateInput || updateInput == 'Twitter'">
        <label for="twitter" class="form-label">Twitter</label>
        <input type="url" id="twitter" formControlName="twitter" class="form-control"
               placeholder="https://twitter.com/yourpage">
      </div>

      <!-- Instagram -->
      <div class="col-md-6" *ngIf="!this.updateInput || updateInput == 'Instagram'">
        <label for="instagram" class="form-label">Instagram</label>
        <input type="url" id="instagram" formControlName="instagram" class="form-control"
               placeholder="https://instagram.com/yourpage">
      </div>

      <!-- LinkedIn -->
      <div class="col-md-6" *ngIf="!this.updateInput || updateInput == 'LinkedIn'">
        <label for="linkedin" class="form-label">LinkedIn</label>
        <input type="url" id="linkedin" formControlName="linkedin" class="form-control"
               placeholder="https://linkedin.com/yourpage">
      </div>

      <!-- WhatsApp -->
      <div class="col-md-6" *ngIf="!this.updateInput || updateInput == 'WhatsApp'">
  <label for="whatsapp" class="form-label">WhatsApp</label>
  <div class="input-group">
    <!-- Country Code Dropdown -->
    <select class="form-select" [(ngModel)]="selectedCountryCode"  [ngModelOptions]="{standalone: true}" style="max-width: 100px;">
      <option value="+91">India (+91)</option>
      <option value="+1">USA (+1)</option>
    </select>

    <!-- Phone Number Input -->
    <input 
      type="tel"
      id="whatsapp"
      formControlName="whatsapp"
      class="form-control"
      placeholder="1234567890"
      maxlength="15"
      pattern="[0-9]*"
      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
    >
  </div>
</div>


    </div>
  </form>



      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModel()">Cancel</button>
        <button class="btn btn-primary" (click)="socialMediaValidation()">{{ isUpdate ? 'Update' : 'Save' }}</button>
      </div>
    </div>
  </div>
</div>






<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>



